import styled from '@emotion/styled';
import { Stack } from '@mui/material';

import { forMobile, theme } from '@/shared/design-system';

export const MatchPanes = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'stretch',
  gap: '24px',
  minWidth: 0,
  [forMobile]: { flexDirection: 'column' },
});

export const ImportedPane = styled(Stack)({
  flexDirection: 'column',
  gap: '12px',
  flex: '0 0 280px',
  minWidth: 0,
  [forMobile]: { flex: 'initial' },
});

export const CandidatesPane = styled(Stack)({
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  minWidth: 0,
  padding: '16px',
  borderRadius: '16px',
  border: `1px solid ${theme.colors.border.default}`,
});

export const ImportedNameRow = styled(Stack)({
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
});
